import { TemplateConfig } from '../types';

export const relationshipDevelopmentThreeMonthsConfig: TemplateConfig = {
  id: 'relationship-development-three-months',
  name: '感情发展趋势三个月',
  description: '分析未来三个月感情的发展阶段与建议',
  cardCount: 4,

  fieldDefaults: {
    title: '感情发展趋势三个月',
    customerQuestion: '分析我和对方之间的感情走向。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 3 张牌'
    ],
    cardInfos: [
      '目前的状态及建议',
      '接下来第一个月的感情发展趋势',
      '接下来第二个月的感情发展趋势',
      '接下来第三个月的感情发展趋势'
    ]
  },

  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],

  generateOptions: {
    normal: true,
    thinking: true
  },

  ui: {
    color: '#f759ab',
    backgroundColor: '#fff0f6',
    icon: '💞'
  }
};
